<div class="mt-6 flex flex-col md:flex-row md:items-start gap-6">
  <!-- LEFT COLUMN -->
  <div class="flex-auto min-w-0 flex flex-col gap-6">
    <div id="user-profile-resume-details-card" class="card">
      <!-- DETAILS CARD -->
      <div class="flex flex-row justify-between items-center px-gutter py-4 border-b">
        <h2 class="title">Détails</h2>
        <button
          color="primary"
          mat-raised-button
          type="button"
          *hasPermission="[ENUM_PERMISSION.UPDATE_INTERNAL_CONTACT]"
          (click)="updateItem()"
        >
          MODIFIER
        </button>
      </div>

      <div
        *ngIf="(userProfileService.entity$ | async)?._id; else loading"
        class="px-gutter py-4 grid grid-cols-1 md:grid-cols-2 gap-4"
      >
        <details-line-base
          [icon]="icPerson"
          [label]="(userProfileService.entity$ | async)?.lastName | uppercase"
          hint="Nom"
        ></details-line-base>

        <details-line-base
          [icon]="icPersonOutline"
          [label]="(userProfileService.entity$ | async)?.firstName | titlecase"
          hint="Prénom"
        ></details-line-base>

        <details-line-base
          [icon]="icPhone"
          [label]="displayPhoneNumbers((userProfileService.entity$ | async)?.phoneNumbers)"
          hint="Téléphone"
        ></details-line-base>

        <details-line-base
          [icon]="icMail"
          [label]="(userProfileService.entity$ | async)?.email"
          hint="Email"
        ></details-line-base>

        <details-line-base
          [icon]="icMail"
          [label]="(userProfileService.entity$ | async)?.mcEmail"
          hint="Email Microsoft"
        ></details-line-base>

        <details-line-base
          [icon]="(userProfileService.entity$ | async)?.affectAllEstablishments ? icCheck : icClose"
          [label]="(userProfileService.entity$ | async)?.affectAllEstablishments ? 'Oui' : 'Non'"
          hint="Affectation à tous les établissements"
        ></details-line-base>

        <details-line-base
          *ngIf="(userProfileService.entity$ | async)?.contactType?.length > 0"
          [icon]="icBusiness"
          [label]="displayContactTypes((userProfileService.entity$ | async)?.contactType)"
          hint="Rôles utilisateur"
        ></details-line-base>

        <details-line-base
          *ngIf="(userProfileService.entity$ | async)?.isPredik"
          [icon]="icBusiness"
          label="Oui"
          hint="Contact Predik"
        ></details-line-base>
      </div>
    </div>

    <!-- AFFECTATIONS CARD -->
    <div id="user-profile-resume-affectations-card" class="card">
      <div class="flex flex-row items-center px-gutter py-4 border-b">
        <h2 class="title m-0 mr-2">Affectations</h2>
        <icon-warning
          [show]="displayAffectationWarning"
          toolTip="Le contact doit avoir au moins 1 affection"
        ></icon-warning>
        <button
          class="ml-auto"
          (click)="createItemAffectation()"
          *hasPermission="[ENUM_PERMISSION.UPDATE_INTERNAL_CONTACT]"
          color="primary"
          mat-raised-button
          type="button"
        >
          AJOUTER
        </button>
      </div>

      <div @stagger class="px-gutter py-4">
        <base-data-table
          [showPaginator]="false"
          [sortField]="sortFieldAffectation"
          [sortOrder]="sortOrderAffectation"
          [dataSource]="dataSourceAffectation"
          [displayedColumns]="displayedColumnsAffectation"
          [feisColumns]="feisColumnsAffectation"
          [accordeonRef]="affectationAccordeonRef"
          [updatePermission]="[ENUM_PERMISSION.UPDATE_INTERNAL_CONTACT]"
          [deletePermission]="[ENUM_PERMISSION.UPDATE_INTERNAL_CONTACT]"
          (onPageEvent)="pageEventAffectation($event)"
          (onSortEvent)="sortEventAffectation($event)"
          (onUpdateItem)="updateItemAffectation($event)"
          (onDeleteItem)="deleteItemAffectation($event)"
        ></base-data-table>

        <ng-template let-row="value" #affectationAccordeonRef>
          <div class="py-2 px-6" *ngIf="getEstablishmentActivities(row.establishment?._id)?.length > 0">
            <div class="flex flex-col gap-1">
              <mat-checkbox
                *ngFor="let activity of getEstablishmentActivities(row.establishment?._id)"
                [checked]="isActivityAffected(row, activity._id)"
                [disabled]="true"
              >
                {{ activity.label }}
              </mat-checkbox>
            </div>
          </div>
          <div
            class="py-2 px-6 text-hint text-xs"
            *ngIf="getEstablishmentActivities(row.establishment?._id)?.length === 0"
          >
            Aucune activité configurée
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- RIGHT COLUMN -->
  <div class="flex-none w-full md:max-w-md flex flex-col gap-6">
    <div id="user-profile-resume-jobs-card" class="card">
      <div class="flex flex-row items-center px-gutter py-4 border-b">
        <h2 class="title m-0 mr-2">Postes</h2>
        <icon-warning [show]="displayPostePercentWarning" toolTip="Le pourcentage doit être égal à 100%"></icon-warning>

        <button
          class="ml-auto"
          (click)="createItemEmployeePosition()"
          *hasPermission="[ENUM_PERMISSION.UPDATE_INTERNAL_CONTACT]"
          color="primary"
          mat-raised-button
          type="button"
        >
          AJOUTER
        </button>
      </div>

      <div class="px-gutter py-3">
        <base-data-table
          [showPaginator]="false"
          [sortField]="sortFieldEmployeePosition"
          [sortOrder]="sortOrderEmployeePosition"
          [dataSource]="dataSourceEmployeePosition"
          [displayedColumns]="displayedColumnsEmployeePosition"
          [feisColumns]="feisColumnsEmployeePosition"
          (onSortEvent)="sortEventEmployeePosition($event)"
          (onUpdateItem)="updateItemEmployeePosition($event)"
          (onDeleteItem)="deleteItemEmployeePosition($event)"
        ></base-data-table>
      </div>
    </div>

    <!-- Maquette d'estimation « action d'équipe » : carte Équipes (données fictives) -->
    <team-action-mock-user-teams-card [linkable]="true" [fictive]="true"></team-action-mock-user-teams-card>

    <ng-container *ngIf="currentUser.isPredik">
      <div class="card" *ngIf="loading">
        <div class="flex flex-row items-center px-gutter py-4 border-b">
          <h2 class="title m-0">Informations de connexion Docuware</h2>
        </div>
        <div class="mt-4 p-4 flex flex-col" [formGroup]="gedForm">
          <base-form-input label="Nom d'utilisateur" controlName="username"></base-form-input>
          <base-form-input type="text" [obscure]="true" label="Mot de passe" controlName="password"></base-form-input>

          <button
            mat-raised-button
            color="primary"
            class="mt-4 self-end"
            (click)="validGedForm()"
            [disabled]="gedForm.invalid"
          >
            ENREGISTRER
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <div class="px-gutter py-4 grid grid-cols-1 md:grid-cols-2 gap-4">
    <details-line-base *ngFor="let _ of skeletonRows" [loading]="true"></details-line-base>
  </div>
</ng-template>
